import React, { useState, useEffect } from 'react';
import './HomePage.css';
import NavBar from '../components/layout/NavBar';
import Banner from '../components/layout/Banner';
import SponsorBanner from '../components/layout/SponsorBanner';
import WhatsApp from '../components/layout/WhatsApp';
import ProductList from '../components/product/ProductList';
import SideBar from '../components/order/SideBar';
import Footer from '../components/layout/Footer';
import { getAdImages, getSponsorIcons, getHighlightedProducts } from '../services/api';
import { Toaster } from 'react-hot-toast';

function HomePage() {
  const [productList, setProductList] = useState([]);
  const [logosList, setLogosList] = useState([]);
  const [adImagesList, setAdImagesList] = useState([]);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [sponsorIcons, adsImages, products] = await Promise.all([
          getSponsorIcons(),
          getAdImages(),
          getHighlightedProducts()
        ]);
  
        setLogosList(sponsorIcons);
        setAdImagesList(adsImages);
        setProductList(products);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
    fetchData();
  }, []);
  

  return (
    <div className="home-container">
      <Toaster />
      <NavBar />
      <Banner imageList={adImagesList}/>
      <div className="home-highlights">
        <div className="home-highlights-content">
          <h1>Productos destacados</h1>
          <ProductList productList={productList} />
        </div>
      </div>
      <WhatsApp />
      <SideBar />
      <SponsorBanner logosList={logosList} />
      <Footer />
    </div>
  );
}

export default HomePage;